import { AccountInfo } from "@azure/msal-browser";

export interface Claims {
    userName?: string;
    firstName?: string;
    lastName?: string;
    emailAddress?: string;
    phoneNumber?: string;
    securityQuestionOne?: string;
    securityQuestionTwo?: string;
    securityQuestionThree?: string;
    sub?: string;
}

export const getClaims = (accounts: AccountInfo[]): Claims => {
    let claims = {};
    if (accounts.length === 1) {
        claims = accounts[0].idTokenClaims ?? {};
    } else {
        const editProfileClaims =
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            accounts.find((a) => (a.idTokenClaims?.acr as any).includes("profileedit")) ?? ({} as AccountInfo);
        claims = editProfileClaims.idTokenClaims ?? {};
        if (!claims) {
            const signInClaims =
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                accounts.find((a) => (a.idTokenClaims?.acr as any).includes("signup_signin")) ?? ({} as AccountInfo);
            claims = signInClaims.idTokenClaims ?? {};
        }
    }

    const claim = {
        // @ts-expect-error
        userName: claims.username,
        // @ts-expect-error
        firstName: claims.given_name,
        // @ts-expect-error
        lastName: claims.family_name,
        // @ts-expect-error
        emailAddress: claims.email || claims.emails?.[0],
        // @ts-expect-error
        phoneNumber: claims.mobile === "0000000000" ? "" : claims.mobile,
        // @ts-expect-error
        securityQuestionOne: claims.question_one,
        // @ts-expect-error
        securityQuestionTwo: claims.question_two,
        // @ts-expect-error
        securityQuestionThree: claims.question_three,
        // @ts-expect-error
        sub: claims.sub
    };
    return claim;
};
